const enemyTypes = {
    SLIDE: 'slide',
    DIE: 'die',
    FALL: 'fall'
}

export default enemyTypes